var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "11px",
    viewBox: "0 0 14 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF00C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Engagement-(Blast)-UI-Design-(D)",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00-D-SQ-Engagement_v3",
    transform: "translate(-425.000000, -640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(121.000000, 568.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-2",
    transform: "translate(298.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9196606,9.33927539 C19.9196606,9.56248994 19.8303748,9.78570449 19.6696603,9.94641897 L11.9910798,17.6249996 C11.8303653,17.785714 11.6071507,17.8749999 11.3839362,17.8749999 C11.1607216,17.8749999 10.9375071,17.785714 10.7767926,17.6249996 L6.33035873,13.1785657 C6.16964425,13.0178512 6.08035843,12.7946367 6.08035843,12.5714221 C6.08035843,12.3482075 6.16964425,12.124993 6.33035873,11.9642785 L7.54464589,10.7499914 C7.70536037,10.5892769 7.92857492,10.4999911 8.15178947,10.4999911 C8.37500402,10.4999911 8.59821858,10.5892769 8.75893305,10.7499914 L11.3839362,13.3839231 L17.241086,7.51784465 C17.4018005,7.35713017 17.6250151,7.26784435 17.8482296,7.26784435 C18.0714442,7.26784435 18.2946587,7.35713017 18.4553732,7.51784465 L19.6696603,8.73213181 C19.8303748,8.89284629 19.9196606,9.11606084 19.9196606,9.33927539 Z",
    id: "\\uF00C"
  })))))));
};
export default SvgCheckMark;